import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { label: 'Income Analytics', to: 'analytics', testId: 'reports-tab-analytics' },
  { label: 'Expense Reports',  to: 'expenses',  testId: 'reports-tab-expenses'  },
  { label: 'Tax Reports',      to: 'tax',       testId: 'reports-tab-tax'       },
];

export function ReportsPage() {
  return (
    <div className="max-w-4xl mx-auto pb-6" data-testid="reports-page">
      <nav
        aria-label="Reports"
        className="px-[var(--page-padding-x)] mb-6"
      >
        <div className="relative border-b border-border">
          <div className="flex gap-1 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
            {tabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                data-testid={tab.testId}
                className={({ isActive }) =>
                  [
                    'px-4 py-2.5 text-sm font-medium transition-colors whitespace-nowrap border-b-2 -mb-px',
                    isActive
                      ? 'border-primary text-primary'
                      : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border',
                  ].join(' ')
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </div>
        </div>
      </nav>
      <Outlet />
    </div>
  );
}

export default ReportsPage;
